import React, { useState } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import Loading from './Loading'

const Login = (props) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e) => {
    props.onLogin({ email, password })
    setEmail('')
    setPassword('')
    e.preventDefault()
  }

  if (props.isAuthenticating) {
    return <Loading />
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol sm="3">
                        <CButton 
                          color="primary" 
                          className="px-4" 
                          type="submit"
                          disabled={!email || !password}
                        >
                          Login
                        </CButton>
                      </CCol>                      
                      <CCol sm="6">
                        {props.error &&
                          <CAlert color="danger" className="p-2">
                            {props.problem}
                          </CAlert>
                        }
                      </CCol>
                      <CCol sm="3" className="text-end">
                        <CButton
                          className="px-4"
                          variant="outline"
                          onClick={() => {
                            if (window.nw && window.nw.Window) {
                              const win = window.nw.Window.get()
                              win.close()
                            } else {
                              window.location.href = '#/'
                            }
                          }}
                        >
                          Cancel
                        </CButton>
                      </CCol>
                                     
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
